module.exports = __webpack_public_path__ + "static/media/Guide_Gestao_Papeis.63ce1b24.pdf";